import { render, staticRenderFns } from "./Strut1500-F.vue?vue&type=template&id=dc80ec24"
import script from "./Strut1500-F.vue?vue&type=script&lang=js"
export * from "./Strut1500-F.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports